module.exports = __webpack_public_path__ + "img/zoe_estates_bg_015.78b161c7.jpg";